import IconCheck from './icon-check';
import IconCopy from './icon-copy';
import IconCalendar from './icon-calendar';
import IconFolder from './icon-folder';
import IconColor from './icon-color';
import IconIndividualRunner from './icon-individual-runner';
import IconTeamRunner from './icon-team-runner';
import IconArrowDown from './icon-arrow-down';
import IconEdit from './icon-edit-pencil';
import IconAlert from './icon-alert';

export {
	IconCheck,
	IconCopy,
	IconCalendar,
	IconFolder,
	IconColor,
	IconIndividualRunner,
	IconTeamRunner,
	IconArrowDown,
	IconEdit,
	IconAlert,
};



// WEBPACK FOOTER //
// ./src/components/ui/layout/icons/index.jsx